import {Api} from "tools/api";
import {i18n} from 'core/localization';
import {getSeverityState} from 'controls/stateRenderer/severityState';
import {dateToString} from "tools/dateTimeUtils";
import {SummaryRouter} from "areas/summary/bundleDescription";
import {EntryType} from "areas/summary/events/eventsSummaryEntry";

const i18n = require('core/localization/localization').translator({
	'Click to view in Eventsummary': {}
});

export async function setMonitorErrorTooltipText(tooltip, monitor, url, target) {
	const eventsSummaryUrl = SummaryRouter.events({entityId: monitor.monitorId, type: [EntryType.MonitorError]})

	let tooltipContent = "";
	if (monitor.agentState === 'ERROR'){
		tooltipContent += '<p class="">' + i18n('Agent Error')
	}
	if (monitor.assetMaintenance) {
		tooltipContent += '<p class="">' + i18n('Asset in maintenance')
	}
	if (monitor.monitorMaintenance) {
		tooltipContent += '<p class="">' + i18n('Monitor in maintenance')
	}
	if(monitor.monitorDataUnavailable){
		tooltipContent += '<p class="">' + i18n('Monitor data unavailable')
	}
	if (monitor.agentState === 'WARNING') {
		if (monitor.monitorError) {
			tooltipContent += '<p class="">' + i18n('Agent in warning') + ' | ' + i18n('Monitor error')
		} else {
			tooltipContent += '<p class="">' + i18n('Agent in warning')
		}
	} else if (monitor.monitorError) {
		tooltipContent += '<p class="">' + i18n('Monitor error')
	}

	if(tooltipContent){
		if(monitor.monitorError){
			tooltipContent += ` - <a href='#${eventsSummaryUrl}'>${i18n('Click to view in Eventsummary')}</a>`;
		}
		tooltipContent += '</p>';
	}

	if(monitor.monitorError){
		const result = await Api.fetch(url);
		if (result && result.length) {
			for (let reason of result) {
				tooltipContent += '<div class="cw_asset_tooltip">';
				tooltipContent += '<span class="cw_severity">' + getSeverityState(reason.severity) + '</span>';
				tooltipContent += '<span class="cw_timestamp">' + dateToString(reason.timestamp, 'datetime') + '</span> - ';
				tooltipContent += '<span class="cw_text">' + reason.text.replace(/\r?\n|\r/g, ' ').substring(0, 200) + '</span> - ';
				tooltipContent += '</div>';
			}
		} else {
			tooltip.options.content = target.attr('cached-title') || '';
		}
	}
	let length = tooltipContent.length;
	let finalContent = '<div style="width: ' + length * 1.2 + 'px;min-width: 200px; max-width: 1000px; ">' + tooltipContent + '</div>';
	tooltip.options.content = finalContent;
	tooltip.refresh();
}
